import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7e3ce94a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "w-full h-full grid justify-center content-center grid-rows-2 gap-1" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "flex justify-center content-center items-center" }, [
    /*#__PURE__*/ _createElementVNode("svg", {
        class: "w-8 h-8 animate-spin -ml-1 mr-3 h-5 w-5 text-white",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24"
    }, [
        /*#__PURE__*/ _createElementVNode("circle", {
            class: "text-primary opacity-75",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            "stroke-width": "4"
        }),
        /*#__PURE__*/ _createElementVNode("path", {
            class: "opacity-50",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        })
    ])
], -1));
const _hoisted_3 = { class: "flex justify-center items-center" };
const _hoisted_4 = { class: "text-primary loading text-center" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_modal = _resolveComponent("modal");
    return (_openBlock(), _createBlock(_component_modal, { line: false }, {
        default: _withCtx(() => [
            _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("h3", _hoisted_4, [
                            _renderSlot(_ctx.$slots, "message", {}, undefined, true)
                        ])
                    ])
                ])
            ])
        ]),
        _: 3
    }));
}
